import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export interface AnalyzeTaskRequest {
    taskDescription: string;
}

export interface TaskAnalysisCategory {
    name: string;
    status: 'ok' | 'warning' | 'critical';
    feedback: string;
    questions: string[];
}

export interface TaskAnalysisResult {
    overallScore: number;
    summary: string;
    categories: TaskAnalysisCategory[];
}

export interface QuestionAnswer {
    question: string;
    answer: string;
}

export interface UpdateTaskRequest {
    originalTask: string;
    answers: QuestionAnswer[];
}

export const AnalyzeTask = (data: AnalyzeTaskRequest) =>
    request({
        url: ApiURL.Command.TaskAnalyzerCommandUrl.AnalyzeTask,
        method: RequestType.POST,
        data: data,
    });

export const UpdateTask = (data: UpdateTaskRequest) =>
    request({
        url: ApiURL.Command.TaskAnalyzerCommandUrl.UpdateTask,
        method: RequestType.POST,
        data: data,
    });
